
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent, PropType} from 'vue';
import Popper from 'vue3-popper/dist/popper.esm';
import {convertInCurrency} from "../../utils/utils";

export default defineComponent({
    name: "OptionBox",
    components: {
        Popper
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        isOptional: {
            type: Boolean,
            required: false,
            default: false
        },
        selectedOption: {
            required: true,
        },
        type: {
            type: String,
            required: true,
            default: 'radio'
        },
        name: {
            type: String,
            required: true,
        },
        getPriceDifference: {
            type: Function,
            required: false,
        },
        selectedCurrency: {
            type: String,
            required: false,
        },
        options: {
            type: Array
        }
    },
    emits: ['changeOption'],
    setup(props, {emit, OptionType}) {
        const checkedInputs = ref([]);

        const onChangeOption = (event, option: String) => {
            if (props.type === 'radio') {
                console.log("change option", option);
                emit('changeOption', option);
            } else {
                if (checkedInputs.value.length > 0 && checkedInputs.value.includes(option) && event.target.checked === false) {
                    checkedInputs.value = checkedInputs.value.filter(item => item !== option);
                } else {
                    checkedInputs.value.push(option);
                }
                checkedInputs.value = [...new Set(checkedInputs.value)];
                emit('changeOption', checkedInputs.value);
            }
        }

        const priceDifference = (optionId) => {
            const priceDifference = props.getPriceDifference(optionId);
            let prefix = priceDifference < 0 ? "" : "+";
            return !isNaN(priceDifference) ?  prefix + convertInCurrency(priceDifference, props.selectedCurrency) : '';
        }

        onMounted(() => {
            checkedInputs.value = props.selectedOption;
        })

        return {
            onChangeOption,
            translate,
            priceDifference
        }
    }
})
